import { useState } from "react";
import { Download, Share, X } from "lucide-react";
import { usePwaInstall } from "../hooks/usePwaInstall";
import { registerMobilePush } from "../services/pushService";
import "./InstallAppButton.css";

function InstallAppButton() {
  const { canInstall, install, isIos, hasNativePrompt } = usePwaInstall();
  const [showIosHint, setShowIosHint] = useState(false);

  if (!canInstall) return null;

  async function handleClick() {
    if (hasNativePrompt) {
      const accepted = await install();
      if (accepted) {
        registerMobilePush().catch(() => {});
      }
      return;
    }
    if (isIos) {
      setShowIosHint((v) => !v);
    }
  }

  return (
    <div className="install-app-wrap">
      {showIosHint && isIos ? (
        <div className="install-app-hint" role="status">
          <button
            type="button"
            className="install-app-hint-close"
            onClick={() => setShowIosHint(false)}
            aria-label="Close install hint"
          >
            <X size={14} />
          </button>
          <p className="install-app-hint-title">Install Smart Farming</p>
          <p className="install-app-hint-text">
            Tap <Share size={12} className="install-app-inline-icon" aria-hidden /> Share, then choose{" "}
            <strong>Add to Home Screen</strong>.
          </p>
        </div>
      ) : null}

      <button type="button" className="install-app-btn" onClick={handleClick} aria-label="Install Smart Farming app">
        <Download size={14} aria-hidden />
        <span>Install app</span>
      </button>
    </div>
  );
}

export default InstallAppButton;
